import { Box } from '@chakra-ui/react';
import { LanguageSwitcher } from './LanguageSwitcher';
import { UsageGuideButton } from './UsageGuideButton';

interface HeaderActionsProps {
  onOpenUsageGuide: () => void;
}

export const HeaderActions = ({ onOpenUsageGuide }: HeaderActionsProps) => {
  return (
    <Box
      position="fixed"
      right={{ base: 3, md: 6 }}
      top={5}
      zIndex="sticky"
      display="flex"
      alignItems="center"
      gap={2}
    >
      <UsageGuideButton onClick={onOpenUsageGuide} />
      <LanguageSwitcher />
    </Box>
  );
};
